import router from '../router'
import {STORE_USER_PLANS} from './constants'

export const ROLE_ADMIN = 'admin'
export const ROLE_EXAMINER = 'examiner'
export const ROLE_USER = 'user'
export const ROLE_TEACHER = 'teacher'
export const ROLE_REGION = 'region'
export const ROLE_SUPER_USER = 'superUser'
export const ROLE_SUPPORT = 'support'

export const userRoles = [
  {id: 1, role: ROLE_ADMIN},
  {id: 2, role: ROLE_EXAMINER},
  {id: 3, role: ROLE_USER},
  {id: 4, role: ROLE_TEACHER},
  {id: 5, role: ROLE_REGION},
  {id: 6, role: ROLE_SUPER_USER},
  {id: 7, role: ROLE_SUPPORT}
]

export const getUserData = () => {
  const userData = localStorage.getItem('user')
  return userData ? JSON.parse(userData) : null
}

export const getUserRole = () => {
  const userData = getUserData()
  if (!userData) {
    return {
      role: null
    }
  }
  return userRoles.find(i => i.id === userData.RoleID)
}

export const isSuperUser = () => getUserRole().role === 'superUser'

export const getUserToken = () => {
  try {
    const userData = getUserData()
    return userData && userData.Token ? userData.Token : null
  } catch (e) {
    return null
  }
}

export const timeFormatted = time => {
  let result = ''
  let h = Math.floor(time / 3600)
  h = h < 10 ? '0' + h : h
  let m = Math.floor((time - h * 3600) / 60)
  m = m < 10 ? '0' + m : m
  let s = (time - h * 3600 - m * 60)
  s = s < 10 ? '0' + s : s
  result += h ? h + ':' : ''
  result += m ? m + ':' : ''
  result += s
  return result
}

export const arrayUnique = arr => {
  return arr.filter((e, i, a) => a.indexOf(e) === i)
}

export const objectArrayUnique = (myArr, prop) =>
  myArr.filter((obj, pos, arr) => arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos)

export const currentUserPlans = () => {
  const data = localStorage.getItem(STORE_USER_PLANS)
  if (data !== undefined) {
    return JSON.parse(data)
  }
  return null
}

/**
 * Возвращает путь по имени
 * @param pathName
 * @param params
 * @returns {string}
 */
export const getRouterPath = (pathName, params = {}) => {
  const path = router.resolve({
    name: pathName,
    params: { ...params }
  })
  return path.href
}



// WEBPACK FOOTER //
// ./src/helpers/index.js